export default {
  "content": "<path d=\"M22.757 5.65l-12 14a1 1 0 01-1.517 0l-6-7 1.517-1.3L10 17.462 21.239 4.35l1.518 1.3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};